import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  input,
  inject,
} from '@angular/core';
import { MapaFacilV2Service } from '../../../../../auxiliares/mapbox/mapa-facil-v2.service';
import mapboxgl from 'mapbox-gl';

@Component({
  selector: 'app-heatmap-cortes',
  templateUrl: './heatmap-cortes.component.html',
  styleUrls: ['./heatmap-cortes.component.scss'],
  standalone: false,
})
export class HeatmapCortesComponent implements OnChanges {
  private mapaFacilV2Service = inject(MapaFacilV2Service);

  @Input() datos: any = {};
  @Input() nombreMap = 'heatmap-cortes-' + Date.now();

  // Signals como app-graficos
  titulo = input<string>('Mapa de Calor');
  altura = input<string>('400px');

  // Mapa
  public map: mapboxgl.Map | null = null;
  private isMapReady = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['datos'] && this.datos) {
      this.actualizarDatos();
    }
  }

  /**
   * Callback cuando el mapa está listo
   */
  public onMapReady(map: mapboxgl.Map): void {
    this.map = map;
    this.isMapReady = true;

    // Cargar datos iniciales si ya estaban disponibles
    if (this.datos) {
      this.actualizarDatos();
    }
  }

  /**
   * Actualiza los datos del mapa
   */
  private actualizarDatos(): void {
    if (!this.isMapReady) return;

    // datos llega en formato MapaFacilData (heatmaps plural, formato legacy)
    // MapaFacilV2Service.updateData() espera MapaFacilV2Data (heatmap singular)
    const heatmapMapa = this.datos?.heatmaps?.[0];

    // Siempre se manda el heatmap (aunque sea con points vacío): el service
    // ignora `heatmap: undefined` y dejaría dibujados los puntos anteriores.
    this.mapaFacilV2Service.updateData({
      heatmap: {
        points: heatmapMapa?.points ?? [],
        radius: heatmapMapa?.radius,
        opacity: heatmapMapa?.opacity,
        gradient: heatmapMapa?.gradient,
      },
      center: this.datos?.center,
      zoom: this.datos?.zoom,
    });
  }
}
